<div class="user-info" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" (click)="openDialog()">
  <button mat-icon-button>
    <mat-icon>account_circle</mat-icon>
  </button>
  <div fxLayout="column">
    <span class="body-1-regular-1">{{loggedInUser}}</span>
    <span class="body-3-default">{{userCompany}}</span>
  </div>
</div>
